import { ISences, TypeClipRule, TypeSpeed, TypeScenes } from "./type";
export const initISencesSetting = {
  material_mute: true,
  type: 2 as TypeScenes, // 1=镜头 2=普通镜头 3=镜尾
  duration: null,
  settings: {
    copy: {
      copy_id: null,
      copy_name: "",
      copy_type: 1,
      variable_key: null,
      variable_name: ""
    },
    general: {
      mode: "follow_audio"
    }
  }
};

export const initISencesItem: Omit<ISences, "id"> = {
  name: "镜头名称",
  materials: [],
  ...initISencesSetting,
};
